export default __webpack_public_path__ + "static/media/bubble_nova_m2.4b707f65.png";